import { render } from "./TahelepanuTeavitused.vue?vue&type=template&id=3f1df068&scoped=true&ts=true"
import script from "./TahelepanuTeavitused.vue?vue&type=script&lang=ts"
export * from "./TahelepanuTeavitused.vue?vue&type=script&lang=ts"

import "./TahelepanuTeavitused.vue?vue&type=style&index=0&id=3f1df068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1df068"]])

export default __exports__